/** US phone display format matching production RegisterForm: (###) ###-#### */
export const formatUsPhoneInput = (value) => {
  const digits = String(value || '')
    .replace(/\D/g, '')
    .slice(0, 10);

  if (!digits.length) {
    return '';
  }
  if (digits.length <= 3) {
    return `(${digits}`;
  }
  if (digits.length <= 6) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  }
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

export const countUsPhoneDigits = (value) => String(value || '').replace(/\D/g, '').length;

export const isUsPhoneComplete = (value) => countUsPhoneDigits(value) === 10;
